import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const ChatIcon = (props) => (
  <SvgIcon {...props}>
    <path
      d="M12 2C6.486 2 2 6.038 2 11C2 16.259 7.04 20.508 13 19.953V22C13.02 21.993 13 23 14 22.451L14.54 22.105C15.672 21.379 21.347 17.477 21.943 11.955C21.98 11.641 22 11.322 22 11C22 6.038 17.514 2 12 2ZM8.5 12H7.5C7.224 12 7 11.776 7 11.5V10.5C7 10.224 7.224 10 7.5 10H8.5C8.776 10 9 10.224 9 10.5V11.5C9 11.776 8.776 12 8.5 12ZM12.5 12H11.5C11.224 12 11 11.776 11 11.5V10.5C11 10.224 11.224 10 11.5 10H12.5C12.776 10 13 10.224 13 10.5V11.5C13 11.776 12.776 12 12.5 12ZM16.5 12H15.5C15.224 12 15 11.776 15 11.5V10.5C15 10.224 15.224 10 15.5 10H16.5C16.776 10 17 10.224 17 10.5V11.5C17 11.776 16.776 12 16.5 12Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

ChatIcon.propTypes = {
  sx: PropTypes.object,
};

export default ChatIcon;
